import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'


 

function* getReviewStatusSaga() {
  try {
    const response: ResponseModel = yield call(service.getReviewStatus)
    yield put(actions.getReviewStatusSuccess(response?.data?.data))
    yield put(actions.getReviewStatusFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getReviewStatusFinish())
  }
}



export function* saga() {
  yield takeLatest(actionTypes.GET_REVIEW_STATUS_START, getReviewStatusSaga)
 
}
